import {useScrollToSection} from '@aboutyou/ui-components';

export const SCROLL_TO_SHOP_THE_LOOK_PARAM = 'scrollToShopTheLook';

export const useShopTheLookScrollManager = () => {
  const {
    disableScrollToSection,
    scrollToSection,
    shouldScrollToSection,
    ScrollToTarget,
  } = useScrollToSection(SCROLL_TO_SHOP_THE_LOOK_PARAM);

  return {
    scrollToShopTheLook: scrollToSection,
    disableScrollToShopTheLook: disableScrollToSection,
    shouldScrollShopTheLookIntoView: shouldScrollToSection,
    ScrollToTarget,
  };
};
